'use client';

import { useState, useEffect } from 'react';
import { cn } from '@bazaar-marketplace/utils';
import { CountdownTimer } from '~/components/countdown-timer/countdown-timer';
import { Typography } from '~/components/typography';

interface DropCountdownTimerProps {
  startTime: string;
  endTime: string;
  className?: string;
  onTimerEnd?: () => void;
}

export const DropCountdownTimer = ({ startTime, endTime, className, onTimerEnd }: DropCountdownTimerProps) => {
  const [now, setNow] = useState(() => new Date().getTime());
  const hasStarted = new Date(startTime).getTime() <= now;

  const targetDateString = hasStarted ? endTime : startTime;
  const labelText = hasStarted ? 'Drop ends in:' : 'Drop starts in:';

  useEffect(() => {
    const targetTime = new Date(targetDateString).getTime();
    const currentTime = new Date().getTime();
    const timeUntilTarget = targetTime - currentTime;
    const SMALL_DELAY_MS = 5;

    if (timeUntilTarget <= 0) {
      return;
    }

    const timeout = setTimeout(() => {
      setNow(new Date().getTime());
    }, timeUntilTarget + SMALL_DELAY_MS);

    return () => {
      clearTimeout(timeout);
    };
  }, [targetDateString]);

  return (
    <div className={cn('flex flex-col items-center gap-1', className)}>
      <Typography className="text-white/60 text-sm font-bold">{labelText}</Typography>
      <div className="h-[80px]">
        <CountdownTimer targetDate={new Date(targetDateString)} onTimerEnd={onTimerEnd} />
      </div>
    </div>
  );
};
